import { CLEAR_SITE_DATA } from '../application';
import { RECEIVE_TAGS } from './actions';

const initialState = {
  tags: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_TAGS: {
      const { tags } = action;
      return { ...state, tags };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
